import { get, post, put, deleted } from '..';
import routes from './routes';

const PurchaseInvoiceServices = {
  createPurchaseInvoice: async (obj) => {
    const data = await post(routes.createPurchaseInvoice, obj);
    return data;
  },
  getPurchaseInvoices: async (params) => {
    const data = await get(routes.getPurchaseInvoices, params);
    return data;
  },
  getPurchaseInvoiceById: async (id) => {
    const data = await get(routes.getPurchaseInvoiceById + id);
    return data;
  },
  updatePurchaseInvoice: async (id, obj) => {
    const data = await put(routes.updatePurchaseInvoice + id, obj);
    return data;
  },
  deletePurchaseInvoice: async (id) => {
    const data = await deleted(routes.deletePurchaseInvoice + id);
    return data;
  },
}

export default PurchaseInvoiceServices